module.exports = __webpack_public_path__ + "static/media/LGSmartRegular__W.3609b20e.eot";